// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"814":"f165370a","854":"f3bcc12e"}[chunkId] + ".chunk.css";
};